// @flow

const DEFAULT_MAP_OPTIONS = { center: { lat: 0, lng: 0 }, zoom: 2 };
const mapIdPrefix = 'map-instance-';
class GoogleMap {
    mapInstances: Array<{
        instance: $FixMe,
        id: string,
        mapDOM: HTMLElement | null
    }> = [];

    initMapInstance: (options: $FixMe) => void = options => {
        const mapDOM = document.createElement('div');
        mapDOM.style.width = '100%';
        mapDOM.style.height = '100%';
        mapDOM.id = `${mapIdPrefix}${this.mapInstances.length}`;
        // google is a global keyword provided by Maps JS API
        this.mapInstances.push({
            instance: new google.maps.Map(mapDOM, options),
            id: mapDOM.id,
            mapDOM
        });
    };

    isAnotherMapInstanceMounted: () => HTMLElement | null = () => {
        return document.querySelector(`[id^="${mapIdPrefix}"]`);
    };

    getAvailableInstance: $FixMe => $FixMe = options => {
        // Loop through instances in the pool and return the first unmounted instance
        for (const curInstance of this.mapInstances) {
            if (!document.querySelector(`#${curInstance.id}`)) {
                return curInstance;
            }
        }
        // If there are no free instances in the pool, create new one
        this.initMapInstance(options);
        return this.mapInstances[this.mapInstances.length - 1];
    };

    init: (domElement: HTMLElement, options: $FixMe) => HTMLElement | null = (
        domElement,
        options = DEFAULT_MAP_OPTIONS
    ) => {
        // If there are no existing map instances
        if (!this.mapInstances.length) {
            this.initMapInstance(options);
        }
        // If there is already 1/more maps mounted, we need to instantiate another map object or reuse one from the pool
        else if (this.isAnotherMapInstanceMounted()) {
            const { instance, mapDOM } = this.getAvailableInstance(options);
            domElement.appendChild(mapDOM);
            instance.setOptions(options);
            return instance;
        }

        domElement.appendChild(this.mapInstances[0].mapDOM);

        /* always update options once the map is mounted for a fresh re-render.
        helps specially for the times when map instances are cached */
        this.updateOptions(options);
        return this.mapInstances[0].instance;
    };

    updateOptions: (options: $FixMe) => void = options => {
        this.mapInstances[0].instance.setOptions(options);
    };
}

const googleMapInstance = new GoogleMap();
export default GoogleMap;
export { googleMapInstance };
